// Account.Email — the normalised sign-in address of an account.
//
// Normalisation (trim + lowercase) happens here, once, at the parse
// boundary, so two spellings of one address are one value. Uniqueness
// across accounts is NOT a domain invariant this module can see: the
// shell's `users.email` unique index enforces it.
export { from, to };
import { Result } from "@bilda/utils";
import * as IdError from "../idError.js";
const mk = (s) => s;
const SHAPE = /^[^\s@]+@[^\s@]+$/;
const to = (raw) => {
    const s = raw.trim().toLowerCase();
    return SHAPE.test(s)
        ? Result.ok(mk(s))
        : Result.err(IdError.mkMalformed("AccountEmail", raw));
};
const from = (email) => email;
//# sourceMappingURL=email.js.map